<template>
  <div class="text-right" v-if="isApp">
    <div>
      <div class="head" >
        <img
          src="../../assets/h5/cb07fd8b-e05f-49f7-913e-60a51c8f992a.png"
          alt="logo"
        />
      </div>
      <div class="body">
        <div class="body-user">
          <div class="user-title">{{ $t("withdrawalLogin.user_id") }}</div>
          <input class="user-ipt" v-model="uid" type="number" />
        </div>

        <div class="body-user mt20">
          <div class="user-title">{{ $t("withdrawalLogin.code") }}</div>
          <div class="Code">
            <input class="user-ipt2" v-model="code" type="number" />
            <button
              @click="gitCode"
              class="code-btn"
              :disabled="status"
              :class="{ bg: bg, 'time-bg': status }"
            >
              {{ status ? txt1 : $t("withdrawalLogin.Send") }}
            </button>
          </div>
          <div v-show="tie" class="tie">{{ $t("withdrawalLogin.text") }}</div>
        </div>
        <div class="body-user mt30">
          <button class="button" :class="{ bg: uid && code }" @click="submit">
            {{ $t("withdrawalLogin.login") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Toast } from "vant";
export default {
  name: "App",
  components: {},
  data() {
    return {
      uid: "",
      code: "",
      bg: false,
      time: 0,
      status: false,
      tie: false,
      txt1: "",
      lang: "",
      deviceId: "",
      userInfo: [],
      isApp: false,
    };
  },
  created() {
    try {
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window["getUserInfo"] = (data) => {
        console.log(data);
        this.userInfo = JSON.parse(data)
        localStorage.setItem("data", JSON.stringify(this.userInfo));
        this.$router.push({ path: "/withdrawal", query: { type: "1" } });
      };
    } catch (err) {
      this.isApp = true;
    }
      this.lang = navigator.language;
    let langs = this.lang.substring(0, 2);
    if (langs == "zh") {
      if (this.lang == "zh-TW" || this.lang == "zh-HK") {
        this.$i18n.locale = "tc";
      } else {
        this.$i18n.locale = "zh";
      }
    } else if (langs == "en") {
      this.$i18n.locale = "en";
    } else if (langs == "ar") {
      this.$i18n.locale = "ar";
    } else if (langs == "tr") {
      this.$i18n.locale = "tr";
    } else if (langs == "es") {
      this.$i18n.locale = "es";
    } else if (langs == "pt") {
      this.$i18n.locale = "pt";
    } else if (langs == "fr") {
      this.$i18n.locale = "fr"
    } else if (langs == "id") {
      this.$i18n.locale = "id"
    } else if (langs == "ms") {
      this.$i18n.locale = "ms"
    } else {
      this.$i18n.locale = "en";
    }
    document.title = this.$t("withdrawalLogin.login");
    document.querySelector("html").setAttribute("lang", this.$i18n.locale);
  },
  mounted() {
    var ids = navigator.userAgent.match(
      /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
    );
    if (ids) {
      ids = ids[0];
    } else {
      ids = "Unknown Device";
    }
    this.deviceId = ids;
  },
  watch: {
    uid: {
      handler(val) {
        if (this.time > 0) {
          return;
        } else {
          if (val) {
            this.bg = true;
          } else {
            this.bg = false;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    gitCode() {
      if (this.uid) {
        this.time = 60;
        this.status = true;
        this.tie = true;
        this.timer();
        this.getCode();
      } else {
        Toast(this.$t("withdrawalLogin.getUserId"));
      }
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.txt1 = this.time + "s";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.txt1 = "";
        this.status = false;
        this.tie = false;
      }
    },

    getCode() {
      axios
        .get(this.$serviceIp + `/api/user/sendCode?uid=${this.uid}`)
        .then((response) => {
          if (response.data.code == 200) {
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },

    submit() {
      if (this.uid && this.code) {
        axios
          .get(
            this.$serviceIp +
              `/api/user/loginVerifyCode?uid=${this.uid}&code=${this.code}`,
            {
              headers: {
                deviceId: this.deviceId,
              },
            }
          )
          .then((response) => {
            if (response.data.code == 200) {
              let expires = Date.now() + 1000 * 60 * 60 * 72;
              localStorage.setItem("time", JSON.stringify(expires));
              localStorage.setItem("data", JSON.stringify(response.data.data));
              Toast(this.$t("withdrawalLogin.loginSuccessful"));
              if (this.$route.query.type == 2) {
                this.$router.push({ path: "/changePic", query: { type: "3" } });
              } else {
                this.$router.push("/withdrawal");
              }
            } else {
              Toast(response.data.message || this.$t("transfer.error"));
            }
          });
      } else {
        return;
      }
    },
  },
};
</script>

<style scoped>
html[lang="ar"] .text-right {
  direction: rtl;
}
.head {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.head img {
  width: 2.21rem;
  height: 3.5rem;
  margin-top: 1.5rem;
}
.body {
  box-sizing: border-box;
  margin-top: 1.5rem;
}
.body-user {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.user-title {
  width: 5.5rem;
  font-size: 0.24rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  margin-bottom: 0.15rem;
}

.user-ipt {
  width: 5.5rem;
  height: 0.82rem;
}
.user-ipt2 {
  width: 2.6rem;
  height: 0.82rem;
}
.code-btn {
  width: 2.5rem;
  height: 0.82rem;
  font-size: 0.24rem;
  color: #acadbc;
  font-family: PingFang SC;
  border-radius: 12px;
  text-align: center;
  line-height: 0.82rem;
  background-color: #f3f3f5;
  border: none;
  box-sizing: border-box;
}

.user-ipt,
.user-ipt2 {
  font-size: 0.27rem;
  border-radius: 12px;
  border: none;
  background-color: #f3f3f5;
  padding-left: 0.27rem;
  padding-right: 0.27rem;
  box-sizing: border-box;
}
.Code {
  width: 5.5rem;
  display: flex;
  justify-content: space-between;
}

.button {
  width: 5.5rem;
  height: 0.9rem;
  font-size: 0.27rem;
  color: #acadbc;
  line-height: 0.9rem;
  font-family: PingFang SC;
  border-radius: 27px;
  text-align: center;
  background-color: #f3f3f5;
  border: none;
  box-sizing: border-box;
}

.mt20 {
  margin-top: 0.3rem;
}
.mt30 {
  margin-top: 0.5rem;
}
.bg {
  color: #ffffff;
  background-color: #00d293;
}
.time-bg {
  color: #000000;
  background-color: #f3f3f5;
}
.tie {
  width: 5.5rem;
  font-size: 0.24rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.29rem;
  color: #acadbc;
  font-family: PingFang SC;
  margin-top: 0.1rem;
}
</style>
